import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import type { RmpTextTag, RmpTextType, RmpTextSize, RmpTextBaseToken, RmpTextFont } from "@rmp/core/components/typography/types";

interface Props {
	tag?: RmpTextTag;
	font?: RmpTextFont;
	type?: RmpTextType;
	size?: RmpTextSize;
	color?: string;
	weight?: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpText',
  props: {
    tag: { default: "p" },
    font: { default: undefined },
    type: { default: "body" },
    size: { default: "medium" },
    color: { default: undefined },
    weight: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { tag: RmpTextTag, font: RmpTextFont, type: RmpTextType, size: RmpTextSize, color: string, weight: number | string };



const textToken = computed<RmpTextBaseToken>(() => {
	const { type, size } = props;
	if (type === "caption" && size === "small") return "caption-small";
	return type === "display" || type === "title" || type === "body"
		? `${type}-${size}`
		: type.replace(/-(regular|bold)$/, "") as RmpTextBaseToken;
});

const textFont = computed(() => props.font ? `var(--rmp-font-${props.font})` : undefined);

const textWeight = computed(() => {
	if(props.weight !== undefined) return props.weight;
	if(props.type.endsWith("-bold")) return 700;
	if(props.type.endsWith("-regular")) return 400;
	return undefined;
});

return { __sfc: true,props, textToken, textFont, textWeight }
}

})